import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, printVariable, searchCompany} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';

// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';

const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const RegisterCompanyPage = ({company}) => {
  const defUrl = '/company'
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  
  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value:-1, visible: false, canSrch: false, selList:[]},
    {field: 'name', placeholder: '업체명',    type:'text', value:'', visible: true, canSrch: true,selList:[]},
    {field: 'bizNum', placeholder: '사업자등록번호',    type:'text', value:'', visible: true, canSrch: true,selList:[]},
    {field: 'ceo', placeholder: '대표자',    type:'text', value:'', visible: true, canSrch: true,selList:[]},
    {field: 'startDt', placeholder: '개업일',    type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'addr1', placeholder: '주소',    type:'text', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'addr2', placeholder: '상세주소',    type:'text', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'manager', placeholder: '담당자', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'phone', placeholder: '대표전화', type:'number', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'email', placeholder: '이메일', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'fax', placeholder: '팩스', type:'number', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'remark', placeholder: '비고', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'bSttCd', placeholder: '사업자상태', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'taxTypeCd', placeholder: '과세유형', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'certified', placeholder: '검증여부', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'reqUserId', placeholder: '신청자ID', type:'text', value:-1, visible: false, canSrch: false, selList:[]},
    {field: 'conUserId', placeholder: '승낙자ID', type:'text', value:-1, visible: false, canSrch: false, selList:[]},
    {field: 'statCode', placeholder: '상태', type:'text', value:'S001', visible: false, canSrch: false, selList:[]},
    {field: 'reqUserId', placeholder: '상태', type:'text', value:'-1', visible: false, canSrch: false, selList:[]},
    {field: 'conUserId', placeholder: '상태', type:'text', value:'-1', visible: false, canSrch: false, selList:[]},
  ]

  

  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []  
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  // const [record, set_record] = useState(xxx)
  const [record, set_record] = useState(company)
  const [dataList, set_dataList] = useState([])
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const certRef = useRef(false)
  
  
  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }

  const dateFormat = 'YYYY-MM-DD HH:mm:ss'

  useEffect(() => {
    onLoad()
  }, [])

  
  const onLoad = async() => {
    openIndicator()
    closeIndicator()
  }

  const onCreate = () => {
    set_record(defRecord)
    dgHandler[1](true)
  }

  ////
  const onSubmit = async () => {
    // printVariable(`activeRow`, activeRow)
    const now = moment().format(dateFormat)
    const url = '/company/register/request'
    const data = {...activeRow, uptTime: now, regTime: now, reqUserId: account.user.id}
  
    const resp = await WebService.post(url, data)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const record = JSON.parse(repMessage.record)
      activeRow.id = record.id
      handleChange()
      openSnackbar('저장되었습니다.')
      onLoad()
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }


  const validate = async(name, value) => {
    let err = ''
    if(name === 'name') {
      if(value === '') {
        err = '업체명을 입력해 주세요.'
      }
    }
    if(name === 'bizNum') {
      const regex = /([0-9]{3})-?([0-9]{2})-?([0-9]{5})/
      if (!regex.test(value)) {
        err = '올바른 사업자번호 형식이 아닙니다.'
      } 
    }
    if(name === 'ceo') {
      if(value.trim() === '') {
        err = '대표자명을 입력해 주세요.'
      }
    }
    if(name === 'startDt') {
      const dt = moment(value, 'YYYYMMDD', true)
      if(!dt.isValid()) {
        err = '날짜포맷에 맞추어 주세요(예, 20210101)'
      }
    }
    if(name === 'certified') {
      if(!certRef.current) {
        err = '사업자 정보가 검증되지 않았습니다.'
      }
    }

    if(name === 'manager') {
      const regex =  /^[가-힣]{2,4}|[a-zA-Z]{2,10}\s[a-zA-Z]{2,10}$/
      if(!regex.test(value)) {
        err = '올바른 이름을 입력해주세요.'
      }
    }
    if(name === 'phone') {
      const regex = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
      if(!regex.test(value)) {
        err = '올바른 전화번호를 입력해주세요.'
      }
    }
    if(name === 'email') {
      const regex = /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
      if (!regex.test(value)) {
        err = '올바른 이메일을 입력해 주세요.'
      } 
    }

    return err
  }
  const [
    activeRow,
    errors,
    formLoading,
    handleChange,
    handleSubmit, 
   ] = useForm({
    initialValues: {...record}, 
    onSubmit: onSubmit,
    validate: validate,
  });

  const [schoolList, set_schoolList] = useState([])
  const [schoolContainer, set_schoolContainer] = useState([])
  const [emailError, setEmailError] = useState('');
  const [passwordState, setPasswordState] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [nameError, setNameError] = useState('');
  const [registerError, setRegisterError] = useState('');

  const testSearch = async(value) => {
  }

  const onValidate = async () => {
    const keys = ['name','bizNum','ceo','startDt']
    let errCount = 0
    
    for(let i=0;i<keys.length;i++) {
      const name = keys[i]
      const value = activeRow[name]
      const err = await handleChange({target:{name:name, value: value}})
      if(err) {
        errCount += 1
      }
    }

    if(errCount === 0) {
      const url = `/public/biz/validate`
      const params = {
        bizNum:activeRow.bizNum,
        startDt:activeRow.startDt,
        ceo:activeRow.ceo,
        name:activeRow.name,
      } 
      const resp = await WebService.get(url, params)
      if(resp.repCode === 'ack') {
        openSnackbar('검증되었습니다.')
        const repMessage = JSON.parse(resp.repMessage)
        const taxTypeCd = repMessage.taxTypeCd
        const bSttCd = repMessage.bSttCd
        certRef.current = true

        activeRow.taxTypeCd = taxTypeCd
        activeRow.bSttCd = bSttCd
        activeRow.certified = true
        handleChange()
      }
      else {
        certRef.current = false
        activeRow.certified = false
        errors.certified = resp.repMessage
        handleChange()
        openSnackbar(resp.repMessage)
      }
    }
  }

  useEffect(() => {
  }, [])

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography component="h1" variant="h5">
          사업자 정보
        </Typography>
        <Boxs component="form" noValidate sx={{ mt: 3 }}>
          <FormControl component="fieldset" variant="standard">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'name'}
                      label={'업체명'}
                      value={activeRow['name']}
                      onChange={handleChange}
                      inputProps={{ maxLength: 64}}
                      disabled={certRef.current}
                    />
                    <FormHelperTexts>{errors['name']}</FormHelperTexts>
                  </Grid>
                  
                  <Grid item xs={2}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'bizNum'}
                      label={'사업자등록번호'}
                      value={activeRow['bizNum']}
                      onChange={handleChange}
                      inputProps={{ maxLength: 10, inputMode: 'numeric'}}
                      disabled={certRef.current}
                    />
                    <FormHelperTexts>{errors['bizNum']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'ceo'}
                      label={'대표자'}
                      value={activeRow['ceo']}
                      onChange={handleChange}
                      inputProps={{ maxLength: 64}}
                      disabled={certRef.current}
                    />
                    <FormHelperTexts>{errors['ceo']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'startDt'}
                      label={'사업자등록증상 개업일 ex. 20010101'}
                      value={activeRow['startDt']}
                      onChange={handleChange}
                      inputProps={{ maxLength: 8}}
                      disabled={certRef.current}
                    />
                    <FormHelperTexts>{errors['startDt']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <Button variant='outlined' color='primary' onClick={()=> {onValidate()}} disabled={false}>검증</Button>
                  </Grid>
                </Grid>
              </Grid>
              <FormHelperTexts>{errors['certified']}</FormHelperTexts>
              
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'manager'}
                      label={'담당자'}
                      value={activeRow['manager']}
                      onChange={handleChange}
                    />
                    <FormHelperTexts>{errors['manager']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'phone'}
                      label={'대표전화'}
                      value={activeRow['phone']}
                      onChange={handleChange}
                    />
                    <FormHelperTexts>{errors['phone']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size='small'
                      required
                      fullWidth
                      name={'email'}
                      label={'이메일'}
                      value={activeRow['email']}
                      onChange={handleChange}
                    />
                    <FormHelperTexts>{errors['email']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </FormControl>
        <FormHelperTexts>{registerError}</FormHelperTexts>
      </Boxs>
     
      <div style={{display:'flex', justifyContent:'center'}}>
        <Button variant='contained' color='primary' size='small' onClick={handleSubmit} sx={{mt: 0, width:100, }}>신청</Button>
      </div>
      <div>
        {renderSnackbar()}
        {renderIndicator()}
      </div>
    </Box>
  </Container>
  );
}

export default RegisterCompanyPage
